import TpCreditMemoItem from '../../Domain/CreditMemo/TpCreditMemoItem';
import SearchParams from '../../Elements/SearchParams';
import TpCreditMemoSearchParams from '../../Contents/Operations/TpCreditMemo/TpCreditMemoSearchParams';
import AuthService from '../authService';

export default class TpCreditMemoService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, TpCreditMemoSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/TpCreditMemo/GetListBySearching/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new TpCreditMemoItem(item));
    }
    return [];
  }

  static GetById(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/TpCreditMemo/GetByIdAsync/${id ? id : 0}`);
  }

  static Upsert(editItem) {
    return AuthService.getInstance().CallBackendFunctionPost('/api/TpCreditMemo/UpsertAsync', JSON.stringify(editItem));
  }

  static StatusChange(editItem) {
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/TpCreditMemo/StatusChangeAsync',
      JSON.stringify(editItem)
    );
  }

  static AttachReportAsync(id) {
    const url = `/api/TpCreditMemo/AttachReportAsync/${id}`;

    return AuthService.getInstance().CallBackendFunctionPut(url);
  }

  static GetInvoicePdfById(item) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpCreditMemo/GetPdfByIdAsync/?searchParams=${JSON.stringify(item)}&clearCache=true`
    );
  }
}
